
<app-message></app-message>
<div class="login-wrapper">
	<div class="login-box">
		<form [formGroup]="loginForm" id="monitor-login"
			(keyup.enter)="login()"
			name="loginForm">
			<input class="userbox"
				placeholder="Email / Username"
				ng-model="username"
				type="text"
				id="monitor_username"
				formControlName="username"
				name="monitor_username"
				placeholder="Email Address"
				autofocus
				required>
				<input class="passbox pwd-control"
				name="monitor_password"
				[type]="showPassword ? 'text' : 'password'"
				formControlName="password"
				id="monitor_password-field"
				placeholder="Password"
				autocomplete="off">
				<button class="sub_button" type="submit" (click)="login()" [disabled]="loaderService.loading">
					<div class="d-flex align-items-center justify-content-center">
						<div class="mr-3">Log In</div>
						<i [hidden]="!loaderService.loading" class="fa fa-spinner fa-pulse fa-spin fa-fw" style="font-size: 24px;"></i>
						<i [hidden]="loaderService.loading" class="fa fa-sign-in" style="font-size: 24px;"></i>
					</div>
			</button>
		</form>
		<div class="forgotpass">
			<a href
				[routerLink]="['/forgotpassword']">Forgot
				Password</a>
		</div>
	</div>
